import createIcon from '../../createIcon';

/**
 * @component @name OndemandVideo
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNOSA3VjE1TDE2IDExTDkgN1pNMjEgM0gzQzEuOSAzIDEgMy45IDEgNVYxN0MxIDE4LjEgMS45IDE5IDMgMTlIOFYyMUgxNlYxOUgyMUMyMi4xIDE5IDIzIDE4LjEgMjMgMTdWNUMyMyAzLjkgMjIuMSAzIDIxIDNaTTIxIDE3SDNWNUgyMVYxN1oiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const OndemandVideo = createIcon('OndemandVideo', [
  [
    'path',
    {
      d: 'M9 7V15L16 11L9 7ZM21 3H3C1.9 3 1 3.9 1 5V17C1 18.1 1.9 19 3 19H8V21H16V19H21C22.1 19 23 18.1 23 17V5C23 3.9 22.1 3 21 3ZM21 17H3V5H21V17Z',
      key: '19x1mk',
    },
  ],
]);

export default OndemandVideo;
